import { render, staticRenderFns } from "./AIContentTrainingBox.vue?vue&type=template&id=23aa49f7&"
import script from "./AIContentTrainingBox.vue?vue&type=script&lang=js&"
export * from "./AIContentTrainingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports